/**
 * @generated SignedSource<<5aa1f9f496fb483e2dd16633d7de899e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraSprintState = "ACTIVE" | "CLOSED" | "FUTURE" | "%future added value";
export type JiraStatusCategoryColor = "BLUE_GRAY" | "BROWN" | "GREEN" | "MEDIUM_GRAY" | "WARM_RED" | "YELLOW" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type useHydratedValues$data = {
  readonly jira?: {
    readonly jqlBuilder: {
      readonly hydrateJqlQuery?: {
        readonly fields?: ReadonlyArray<{
          readonly field?: {
            readonly displayName: string | null | undefined;
            readonly searchTemplate: {
              readonly key: string | null | undefined;
            } | null | undefined;
            readonly shouldShowInContext: boolean | null | undefined;
          };
          readonly jqlTerm?: string;
          readonly values?: ReadonlyArray<{
            readonly error?: {
              readonly __typename: "QueryError";
            } | null | undefined;
            readonly jqlTerm?: string;
            readonly values?: ReadonlyArray<{
              readonly __typename: string;
              readonly displayName: string;
              readonly issue?: {
                readonly fields: {
                  readonly edges: ReadonlyArray<{
                    readonly node: {
                      readonly text?: string | null | undefined;
                    } | null | undefined;
                  } | null | undefined> | null | undefined;
                } | null | undefined;
              };
              readonly issueTypes?: ReadonlyArray<{
                readonly avatar: {
                  readonly xsmall: string | null | undefined;
                } | null | undefined;
              }>;
              readonly jqlTerm: string;
              readonly priority?: {
                readonly iconUrl: AGG$URL | null | undefined;
              };
              readonly project?: {
                readonly avatar: {
                  readonly small: string | null | undefined;
                } | null | undefined;
                readonly key: string;
              };
              readonly sprint?: {
                readonly boardName: string | null | undefined;
                readonly state: JiraSprintState | null | undefined;
              };
              readonly statusCategory?: {
                readonly colorName: JiraStatusCategoryColor | null | undefined;
              };
              readonly user?: {
                readonly picture: AGG$URL;
              } | null | undefined;
            } | null | undefined>;
          } | null | undefined>;
        }>;
        readonly jql?: string | null | undefined;
        readonly message?: string | null | undefined;
      } | null | undefined;
      readonly hydrateJqlQueryForFilter?: {
        readonly fields?: ReadonlyArray<{
          readonly field?: {
            readonly displayName: string | null | undefined;
            readonly searchTemplate: {
              readonly key: string | null | undefined;
            } | null | undefined;
            readonly shouldShowInContext: boolean | null | undefined;
          };
          readonly jqlTerm?: string;
          readonly values?: ReadonlyArray<{
            readonly error?: {
              readonly __typename: "QueryError";
            } | null | undefined;
            readonly jqlTerm?: string;
            readonly values?: ReadonlyArray<{
              readonly __typename: string;
              readonly displayName: string;
              readonly issue?: {
                readonly fields: {
                  readonly edges: ReadonlyArray<{
                    readonly node: {
                      readonly text?: string | null | undefined;
                    } | null | undefined;
                  } | null | undefined> | null | undefined;
                } | null | undefined;
              };
              readonly issueTypes?: ReadonlyArray<{
                readonly avatar: {
                  readonly xsmall: string | null | undefined;
                } | null | undefined;
              }>;
              readonly jqlTerm: string;
              readonly priority?: {
                readonly iconUrl: AGG$URL | null | undefined;
              };
              readonly project?: {
                readonly avatar: {
                  readonly small: string | null | undefined;
                } | null | undefined;
                readonly key: string;
              };
              readonly sprint?: {
                readonly boardName: string | null | undefined;
                readonly state: JiraSprintState | null | undefined;
              };
              readonly statusCategory?: {
                readonly colorName: JiraStatusCategoryColor | null | undefined;
              };
              readonly user?: {
                readonly picture: AGG$URL;
              } | null | undefined;
            } | null | undefined>;
          } | null | undefined>;
        }>;
        readonly jql?: string | null | undefined;
        readonly message?: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly user?: {
    readonly picture: AGG$URL;
  } | null | undefined;
  readonly " $fragmentType": "useHydratedValues";
};
export type useHydratedValues$key = {
  readonly " $data"?: useHydratedValues$data;
  readonly " $fragmentSpreads": FragmentRefs<"useHydratedValues">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "picture"
  }
],
v1 = {
  "kind": "Variable",
  "name": "scope",
  "variableName": "scope"
},
v2 = {
  "kind": "Variable",
  "name": "viewContext",
  "variableName": "viewContext"
},
v3 = {
  "kind": "ScalarField",
  "name": "jqlTerm"
},
v4 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v5 = {
  "kind": "ScalarField",
  "name": "key"
},
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v7 = [
  {
    "concreteType": "JiraStatusCategory",
    "kind": "LinkedField",
    "name": "statusCategory",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "colorName"
      }
    ]
  }
],
v8 = [
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "kind": "ScalarField",
        "name": "jql"
      },
      {
        "kind": "LinkedField",
        "name": "fields",
        "plural": true,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              {
                "concreteType": "JiraJqlField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "concreteType": "JiraJqlSearchTemplate",
                    "kind": "LinkedField",
                    "name": "searchTemplate",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "shouldShowInContext"
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "name": "values",
                "plural": true,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "values",
                        "plural": true,
                        "selections": [
                          (v6/*: any*/),
                          (v3/*: any*/),
                          (v4/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "project",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "small"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ],
                            "type": "JiraJqlProjectFieldValue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v7/*: any*/),
                            "type": "JiraJqlStatusFieldValue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v7/*: any*/),
                            "type": "JiraJqlStatusCategoryFieldValue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "issueTypes",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "xsmall"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ],
                            "type": "JiraJqlIssueTypeFieldValue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": (v0/*: any*/)
                              }
                            ],
                            "type": "JiraJqlUserFieldValue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraPriority",
                                "kind": "LinkedField",
                                "name": "priority",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "iconUrl"
                                  }
                                ]
                              }
                            ],
                            "type": "JiraJqlPriorityFieldValue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "issue",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueFieldConnection",
                                    "kind": "LinkedField",
                                    "name": "fields",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "text"
                                                  }
                                                ],
                                                "type": "JiraSingleLineTextField"
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ],
                            "type": "JiraJqlIssueFieldValue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraSprint",
                                "kind": "LinkedField",
                                "name": "sprint",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "state"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "boardName"
                                  }
                                ]
                              }
                            ],
                            "type": "JiraJqlSprintFieldValue"
                          }
                        ]
                      }
                    ],
                    "type": "JiraJqlQueryHydratedValue"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      {
                        "concreteType": "QueryError",
                        "kind": "LinkedField",
                        "name": "error",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/)
                        ]
                      }
                    ],
                    "type": "JiraJqlQueryHydratedError"
                  }
                ]
              }
            ],
            "type": "JiraJqlQueryHydratedField"
          }
        ]
      }
    ],
    "type": "JiraJqlHydratedQuery"
  },
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "kind": "ScalarField",
        "name": "message"
      }
    ],
    "type": "QueryError"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "accountId"
    },
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "filterAri"
    },
    {
      "kind": "RootArgument",
      "name": "includeJira"
    },
    {
      "kind": "RootArgument",
      "name": "includeUser"
    },
    {
      "kind": "RootArgument",
      "name": "isFilter"
    },
    {
      "kind": "RootArgument",
      "name": "jql"
    },
    {
      "kind": "RootArgument",
      "name": "scope"
    },
    {
      "kind": "RootArgument",
      "name": "viewContext"
    }
  ],
  "kind": "Fragment",
  "name": "useHydratedValues",
  "selections": [
    {
      "condition": "includeUser",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "accountId",
              "variableName": "accountId"
            }
          ],
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": (v0/*: any*/)
        }
      ]
    },
    {
      "condition": "includeJira",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "args": [
                {
                  "kind": "Variable",
                  "name": "cloudId",
                  "variableName": "cloudId"
                }
              ],
              "concreteType": "JiraJqlBuilder",
              "kind": "LinkedField",
              "name": "jqlBuilder",
              "plural": false,
              "selections": [
                {
                  "condition": "isFilter",
                  "kind": "Condition",
                  "passingValue": false,
                  "selections": [
                    {
                      "args": [
                        {
                          "kind": "Variable",
                          "name": "query",
                          "variableName": "jql"
                        },
                        (v1/*: any*/),
                        (v2/*: any*/)
                      ],
                      "kind": "LinkedField",
                      "name": "hydrateJqlQuery",
                      "plural": false,
                      "selections": (v8/*: any*/)
                    }
                  ]
                },
                {
                  "condition": "isFilter",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "args": [
                        {
                          "kind": "Variable",
                          "name": "id",
                          "variableName": "filterAri"
                        },
                        (v1/*: any*/),
                        (v2/*: any*/)
                      ],
                      "kind": "LinkedField",
                      "name": "hydrateJqlQueryForFilter",
                      "plural": false,
                      "selections": (v8/*: any*/)
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "ca3de7c8645b6f4d9524497f325707e2";

export default node;
